import handleResponse from './handle-response';
import $axios from '../services';

const ERROR_PAYLOAD = {
  success: false,
  data: { message: 'A server error occurred.' },
  message: 'Se produjo un error de comunicación con el servidor.',
};

const handleError = async (error) => {
  const hasResponse = error.response && (typeof error.response.data === 'object');
  if (hasResponse) {
    const errorData = error.response.data.error;
    return { ...ERROR_PAYLOAD, data: errorData, message: errorData.errorMessage };
  }
  return ERROR_PAYLOAD;
};

const handleRequest = async (method, url, data = null, config = {}, headers = {}) => {
  try {
    const methods = {
      get: {
        ...config, method, url, params: { ...data }, headers,
      },
      post: {
        ...config, method, url, data, headers,
      },
      put: {
        ...config, method, url, data, headers,
      },
      delete: {
        ...config, method, url, headers,
      },
      default: {
        ...config, method, url,
      },
    };
    const requestConfig = methods[method] || methods.default;
    const response = await $axios(requestConfig);
    const payload = await handleResponse(response);
    return payload;
  } catch (error) {
    return handleError(error);
  }
};

export default handleRequest;
